import { NgModule } from '@angular/core';

import { ReportListModule } from './report-list/report-list.module';
import { ReportProgressModule } from './report-progress/report-progress.module';
import { ReportSelectorModule } from './report-selector/report-selector.module';

@NgModule({
  exports: [ReportListModule, ReportProgressModule, ReportSelectorModule]
})
export class ReportModule {}
